import dictionary from "../langs.json";

export enum TaskTypeEnum {
  Pencil = 0,
  Blocks,
  Table,
}

export function getTaskTypeString(type: TaskTypeEnum) {
  return dictionary.ru.translation[
    ("taskType" + type) as keyof typeof dictionary.ru.translation
  ];
}

export let isTaskType = (variable: unknown): variable is TaskTypeEnum => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "number" &&
    variable in TaskTypeEnum
  );
};
